import * as React from "react";
import PropTypes from "prop-types";
import { QontoStepIconRoot } from "./MDStepperRoot";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { ArrowBack, ArrowBackIosNew } from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import colors from "assets/theme/base/colors";
import pxToRem from "assets/theme/functions/pxToRem";

function StepComponent(props) {
  const { active, completed, className, color, index, label, finish, onClick } = props;
  const { primary, light } = colors;
  const Wrapper = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
  }));

  const Line = styled("div")(({ theme, ownerState }) => {
    const { breakpoints } = theme;
    return {
      width: pxToRem(20),
      border: `1px solid ${primary.main} `,
      marginLeft: pxToRem(8),
      [breakpoints.up("xl")]: {
        display: "none",
      },
    };
  });
  const CompleteLine = styled("div")(({ theme, ownerState }) => {
    const { breakpoints } = theme;
    return {
      width: pxToRem(20),
      border: `1px solid ${primary.disable} `,
      marginLeft: pxToRem(8),
      [breakpoints.up("xl")]: {
        display: "none",
      },
    };
  });
  return completed ? (
    <Wrapper>
      <QontoStepIconRoot onClick={onClick} ownerState={{ active, color }} className={className}>
        <div className="QontoStepIcon-completedIcon">
          <div className="QontoStepIcon-completedIcon-inner">
            <MDTypography color="white" component="p">
              {index + 1}
            </MDTypography>
          </div>
        </div>
        <MDTypography
          sx={({ breakpoints }) => ({
            [breakpoints.down("xl")]: {
              display: "none",
            },
          })}
          ml={1.2}
          mr={0.8}
          fontSize="xs"
          fontWeight="bold"
        >
          {label}
        </MDTypography>
        {!finish && <Line />}
        {!finish && <ArrowBackIosNew color="black" />}
      </QontoStepIconRoot>
      <MDTypography
        sx={({ breakpoints }) => ({
          [breakpoints.up("xl")]: {
            display: "none",
          },
          mt: 2,
        })}
        ml={1.2}
        mr={0.8}
        fontSize="xxs"
        fontWeight="bold"
      >
        {label}
      </MDTypography>
    </Wrapper>
  ) : (
    <Wrapper>
      <QontoStepIconRoot onClick={onClick} ownerState={{ active, color }} className={className}>
        <div className="QontoStepIcon-Icon">
          <div className="QontoStepIcon-Icon-inner">
            <MDTypography color="white" component="p">
              {index + 1}
            </MDTypography>
          </div>
        </div>
        <MDTypography
          sx={({ breakpoints }) => ({
            color: primary.disable,
            [breakpoints.down("xl")]: {
              display: "none",
            },
          })}
          ml={1.2}
          mr={0.6}
          fontSize="xs"
          fontWeight="bold"
        >
          {label}
        </MDTypography>
        {!finish && <CompleteLine />}
        {!finish && <ArrowBackIosNew color="black" />}
      </QontoStepIconRoot>
      <MDTypography
        sx={({ breakpoints }) => ({
          color: primary.disable,
          [breakpoints.up("xl")]: {
            display: "none",
          },
          mt: 2,
        })}
        ml={1.2}
        mr={0.8}
        fontSize="xxs"
        fontWeight="bold"
      >
        {label}
      </MDTypography>
    </Wrapper>
  );
}
export default function MDStepper(props) {
  const {
    steps,
    activeStep,
    color,
    icon,
    title,
    dateTime,
    content,
    close,
    bgWhite,
    onClick,
    ...rest
  } = props;
  return (
    <MDBox display="flex">
      {steps.map((step, index) => (
        <StepComponent
          index={index}
          label={step}
          onClick={() => {
            onClick(index);
          }}
          completed={activeStep >= index ? true : false}
          finish={index === steps.length - 1}
        />
      ))}
    </MDBox>
  );
}
MDStepper.defaultProps = {
  color: "success",
};
MDStepper.propTypes = {
  /**
   * empty array
   * @default []
   */
  steps: PropTypes.array,
  activeStep: PropTypes.number,
};
